// extracted by mini-css-extract-plugin
export var container = "styles-module--container--28ovx";
export var external = "styles-module--external--wCIMY";
export var internal = "styles-module--internal--bW9KX";
export var isWhite = "styles-module--isWhite--+B00+";
export var menuPrinicipal = "styles-module--menuPrinicipal--HzU5x";
export var separacion = "styles-module--separacion--6Hgqb";
export var separacionArea = "styles-module--separacionArea--kEbbu";